

import React from 'react'
import './StepSection.css'
import { Container, Row, Col } from 'reactstrap'
import { Link } from 'react-router-dom'

const StepSection = () => {

    const STEP__DATA = [
        {
            title: 'Setup your Wallet',
            desc: 'Es un hecho establecido hace demasiado tiempo que un lector se distraerá con el contenido ',
            icon: 'ri-wallet-line'
        },

        {
            title: 'Create your Collection',
            desc: 'Es un hecho establecido hace demasiado tiempo que un lector se distraerá con el contenido ',
            icon: 'ri-layout-masonry-line'
        },

        {
            title: 'Add your NFTs',
            desc: 'Es un hecho establecido hace demasiado tiempo que un lector se distraerá con el contenido ',
            icon: 'ri-image-line'
        },

        {
            title: 'List them for Sale',
            desc: 'Es un hecho establecido hace demasiado tiempo que un lector se distraerá con el contenido ',
            icon: 'ri-list-check'
        }
    ]


  return (
    <section>
    <Container>
        <Row>
            <Col lg='12'>
            <h3 className='step-title'>
                Create and Sell Your NFTs
            </h3>
            </Col>

            {
                STEP__DATA.map((item,index) =>
                <Col lg='3' md='4' sm='6' key={index} className='mb-4'>
            <div className='single_step_item'>
                <span>
                <i class={item.icon}></i>

                </span>
                <div className='step_item_content'>
                    <h5><Link to='/wallet'> {item.title}</Link></h5>
                    <p className='mb-0'> {item.desc}</p>
                </div>
            </div>

            </Col>) 
            }



           
        </Row>
    </Container>

    </section>
  )
}

export default StepSection